/* Real Shopify selling_plan submission. No subscription contracts are created by the theme. */
if (!customElements.get('nn-quantity-packs')) {
  customElements.define('nn-quantity-packs', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.quantityInput = this.querySelector('[data-nn-quantity-input]');
      this.owner = this.closest('product-info');
      this.onQuantityChange = (event) => {
        if (!event.target.matches('input[type="radio"]')) return;
        const quantity = event.target.value;
        this.quantityInput.value = quantity;
        const EventClass = this.ownerDocument.defaultView.Event;
        this.quantityInput.dispatchEvent(new EventClass('change', { bubbles: true }));
        const CustomEventClass = this.ownerDocument.defaultView.CustomEvent;
        this.owner?.dispatchEvent(new CustomEventClass('nn:quantity-change', { detail: { quantity } }));
      };
      this.onPurchaseChange = (event) => this.renderPrices(event.detail?.planId || '');
      this.addEventListener('change', this.onQuantityChange);
      this.owner?.addEventListener('nn:purchase-change', this.onPurchaseChange);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onQuantityChange);
      this.owner?.removeEventListener('nn:purchase-change', this.onPurchaseChange);
      this.initialized = false;
    }

    renderPrices(planId) {
      this.querySelectorAll('[data-nn-quantity-price]').forEach((price) => {
        const plan = Array.from(price.querySelectorAll('template[data-nn-quantity-plan]'))
          .find((node) => node.dataset.nnQuantityPlan === String(planId));
        const source = plan || price.querySelector('template[data-nn-quantity-once]');
        const active = price.querySelector('[data-nn-quantity-active]');
        if (source && active) active.replaceChildren(source.content.cloneNode(true));
      });
      this.querySelectorAll('[data-nn-quantity-saving]').forEach((saving) => {
        const plan = Array.from(saving.querySelectorAll('template[data-nn-quantity-saving-plan]'))
          .find((node) => node.dataset.nnQuantitySavingPlan === String(planId));
        const source = plan || saving.querySelector('template[data-nn-quantity-saving-once]');
        const active = saving.querySelector('[data-nn-quantity-saving-active]');
        if (source && active) active.replaceChildren(source.content.cloneNode(true));
      });
    }
  });
}

if (!customElements.get('nn-purchase')) {
  customElements.define('nn-purchase', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.onChange = (event) => {
        if (event.target.matches('input[type="radio"]')) {
          if (event.target.value === 'once') this.select.value = '';
          else this.select.value = this.lastPlan || this.firstPlan();
        }
        if (this.select?.value) this.lastPlan = this.select.value;
        this.renderSelection(true);
      };
      this.addEventListener('change', this.onChange);
      this.owner = this.closest('product-info');
      this.onQuantityChange = (event) => {
        this.dataset.quantity = String(event.detail?.quantity || '1');
        this.renderSelection(false);
      };
      this.owner?.addEventListener('nn:quantity-change', this.onQuantityChange);
      this.initialize();
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          const owner = this.closest('product-info');
          if (String(data.sectionId) !== String(owner?.sectionId || this.dataset.section)) return;
          const source = data.html.querySelector('nn-purchase');
          if (!source) return;
          const previousMode = this.select?.value ? 'subscription' : 'once';
          const previousPlan = this.lastPlan;
          const hadPlans = Boolean(this.select);
          this.innerHTML = source.innerHTML;
          this.dataset.defaultMode = source.dataset.defaultMode;
          this.dataset.required = source.dataset.required;
          this.initialize(hadPlans ? previousMode : undefined, previousPlan);
          this.renderSelection(true);
        });
      }
    }

    disconnectedCallback() {
      this.unsubscribe?.();
      this.removeEventListener('change', this.onChange);
      this.owner?.removeEventListener('nn:quantity-change', this.onQuantityChange);
      this.initialized = false;
    }

    firstPlan() {
      return Array.from(this.select?.options || []).find((option) => option.value)?.value || '';
    }

    initialize(mode, plan) {
      this.select = this.querySelector('select[name="selling_plan"]');
      this.setAttribute('data-ready', '');
      if (!this.select) {
        this.renderSelection(false);
        return;
      }
      const available = Array.from(this.select.options).map((option) => option.value);
      this.lastPlan = available.includes(plan) && plan ? plan : this.firstPlan();
      if (mode === 'once' && this.dataset.required !== 'true') this.select.value = '';
      else if (mode === 'subscription' || this.dataset.required === 'true') this.select.value = this.lastPlan;
      else if (this.select.value) this.lastPlan = this.select.value;
      this.renderSelection(false);
    }

    renderSelection(updateURL) {
      const isSubscription = Boolean(this.select?.value);
      this.querySelectorAll('input[type="radio"]').forEach((radio) => {
        radio.checked = radio.value === (isSubscription ? 'subscription' : 'once');
      });
      // Keep the single named select enabled even when hidden: an empty value means a one-time purchase.
      const planControls = this.querySelector('[data-plan-controls]');
      const subscriptionTerms = this.querySelector('[data-subscription-terms]');
      if (planControls) planControls.hidden = !isSubscription;
      if (subscriptionTerms) subscriptionTerms.hidden = !isSubscription;
      const quantity = String(this.dataset.quantity || '1');
      const source = isSubscription
        ? Array.from(this.querySelectorAll('template[data-plan-id][data-quantity]')).find((node) => node.dataset.planId === this.select?.value && node.dataset.quantity === quantity)
        : Array.from(this.querySelectorAll('template[data-once-quantity]')).find((node) => node.dataset.onceQuantity === quantity);
      const fallback = isSubscription
        ? Array.from(this.querySelectorAll('template[data-plan-id][data-quantity="1"]')).find((node) => node.dataset.planId === this.select?.value)
        : this.querySelector('template[data-once-quantity="1"]');
      const target = this.querySelector('[data-active-summary]');
      const summarySource = source || fallback;
      if (summarySource && target) target.replaceChildren(summarySource.content.cloneNode(true));
      const form = this.closest('form');
      const button = form?.querySelector('button[name="add"] > span:first-child');
      if (button && !form.querySelector('button[name="add"]')?.disabled) {
        button.textContent = isSubscription ? 'Abo in den Warenkorb' : (window.variantStrings?.addToCart || 'In den Warenkorb');
      }
      this.syncMerchandising();
      const owner = this.closest('product-info');
      if (updateURL && owner?.dataset.updateUrl === 'true') {
        const url = new URL(window.location.href);
        if (isSubscription) url.searchParams.set('selling_plan', this.select?.value);
        else url.searchParams.delete('selling_plan');
        window.history.replaceState({}, '', url);
      }
    }

    syncMerchandising() {
      const owner = this.closest('product-info');
      if (!owner) return;
      const planId = this.select?.value || '';
      const findTemplate = (scope, attribute, value) => Array.from(scope.querySelectorAll('template[' + attribute + ']')).find(node => node.getAttribute(attribute) === value);
      const headline = planId ? findTemplate(this, 'data-nn-headline-plan', planId) : this.querySelector('template[data-nn-headline-once]');
      const topPrice = owner.querySelector('[data-nn-top-price]');
      if (headline && topPrice) topPrice.replaceChildren(headline.content.cloneNode(true));
      const savings = findTemplate(this, 'data-nn-savings-plan', planId || this.lastPlan);
      const savingLabel = this.querySelector('[data-nn-savings]');
      if (savingLabel) savingLabel.replaceChildren(...(savings ? [savings.content.cloneNode(true)] : []));
      owner.querySelectorAll('[data-nn-pack-price]').forEach(tile => {
        const matchingPlan = planId && findTemplate(tile, 'data-nn-pack-plan', planId);
        const source = matchingPlan || tile.querySelector('template[data-nn-pack-once]');
        const active = tile.querySelector('[data-nn-pack-active]');
        if (source && active) active.replaceChildren(source.content.cloneNode(true));
        if (!matchingPlan && tile.dataset.required === 'true') {
          const mode = document.createElement('span');
          mode.className = 'nn-price-mode';
          mode.textContent = 'Nur im Abo · Lieferplan wählen';
          active.replaceChildren(mode);
        }
      });
      const CustomEventClass = owner.ownerDocument.defaultView.CustomEvent;
      owner.dispatchEvent(new CustomEventClass('nn:purchase-change', { detail: { planId } }));
    }

  });
}
